import type { Entries } from 'type-fest/source/entries'

import { countryRoutes } from '@/constants/pickerRegions/regions'
import type { SupportedAlpha3CountryCode } from './getSupportedAlpha3CountryCodes'

export const toAlpha2 = (alpha3: SupportedAlpha3CountryCode) => {
  const countryRouteEntries = Object.entries(countryRoutes) as Entries<
    typeof countryRoutes
  >

  for (const [alpha2, currentAlpha3] of countryRouteEntries) {
    if (currentAlpha3.toLocaleLowerCase() === alpha3.toLocaleLowerCase()) {
      return alpha2
    }
  }

  return null
}
